import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tos-en',
  templateUrl: './tos-en.component.html',
  styleUrls: ['./tos-en.component.scss']
})
export class TosEnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
